import * as React from "react";
import {handleError, Project} from "../../_helpers";
import LoadingOverlay from "@ronchalant/react-loading-overlay";
import {AccountsPageProps, Accounts} from "./Accounts";
import {Exchange} from "../../_services";
import {Container} from "react-bootstrap";
import {Api} from "../../_api";
import {useEffect, useState} from "react";

export interface ExchangePageProps<o> {
    getId(order: o): number,
    getPrice(order: o): number,
    getAmount(order: o): number,
    isAsk(order: o): boolean,
    getQuoteCurrency(order: o): string,
    configFields: $ObjMap,
    exchange: string,
}
export const ExchangePage = (props: ExchangePageProps) => {

    const [errorMessage, setErrorMessage] = useState('')
    const [exchange, setExchange] = useState({})
    const [showConfig, setShowConfig] = useState(false)
    const [loaded, setLoaded] = useState(false)

    const errorHandler = {
        setState: (s) => {
            if (s.errorMessage !== 'undefined') {
                setErrorMessage(s.errorMessage)
            }
        }
    };

    const currency = Project.current.base_currency
    const api = Api.forExchange(props.exchange)

    const _delete = account => {
        if (!window.confirm("Are you sure you want to delete account: " + account + "?")) {
            return
        }
        api.forAccount(account).deleteAccount().then(() => _update())
    }
    const _update = () => api.configs()
        .then(config => {
            const showConfig = {}
            Object.keys(config).forEach(k => {
                showConfig[k] = !config[k][Object.keys(props.configFields)[0]]
            })
            setExchange(config)
            setLoaded(true)
            setShowConfig(showConfig)
        })
        .catch(handleError(errorHandler))

    const orderFns = {
        getId: props.getId,
        getPrice: props.getPrice,
        getAmount: props.getAmount,
        isAsk: props.isAsk,
        getQuoteCurrency: props.getQuoteCurrency,
        currency: currency,
    }

    useEffect(() => {
        if (!loaded) {
            _update()
        }
    }, [loaded])

    const accountsProps: AccountsPageProps = {
        onConfigSubmit: (account) => (values, actions) => {
            const config = {}
            for (const confKey in props.configFields) {
                config[confKey] = values[confKey]
            }
            api.forAccount(account).saveConfig(config)
                .then(() => setLoaded(false))
                .then(() => actions.setSubmitting(false))
                .catch(handleError(errorHandler))
        },
        configFields: props.configFields,
        exchangeObj: exchange,
        setExchangeObj: setExchange,
        showConfig: showConfig,
        setShowConfig: setShowConfig,
        exchange: props.exchange,
        orderFns: orderFns,
        "delete": _delete
    }

    return <Container fluid>
        <LoadingOverlay active={!loaded} spinner text='Loading...'>
            <h1>
                <span>{Exchange.of(props.exchange).name()}</span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <a className="btn btn-sm btn-dark"
                   href={`/exchange/${props.exchange}/orderBook`}>OrderBook</a>
            </h1>
            {errorMessage && <div className="alert alert-danger" role="alert"> {errorMessage} </div>}
            <Accounts {...accountsProps} />
        </LoadingOverlay>
    </Container>
}
